import { render, staticRenderFns } from "./viewMoreButton.vue?vue&type=template&id=6f9f920a&scoped=true&"
import script from "./viewMoreButton.vue?vue&type=script&lang=js&"
export * from "./viewMoreButton.vue?vue&type=script&lang=js&"
import style0 from "./viewMoreButton.vue?vue&type=style&index=0&id=6f9f920a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f920a",
  null
  
)

export default component.exports